import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Button } from '@src/components/Button';
import FrCheckSvg from '@src/svgs/fr-check.svg';
import { MessageSentProps } from './props';
import './styles.scss';

export const MessageSent: FC<MessageSentProps> = ({ closeModal }) => {
  return (
    <div className="message-sent-modal">
      <div className="message-sent-modal__container">
        <Svg className="message-sent-modal__icon" src={FrCheckSvg} />

        <h3 className="message-sent-modal__title">Message sent</h3>

        <p className="message-sent-modal__text">Your message will be delivered directly to their inbox.</p>

        <Button onClick={() => closeModal?.()}>Close</Button>
      </div>
    </div>
  );
};
